import React from 'react';

import { Wrapper } from './styles';

export interface Props {
  color?: string;
  text?: string;
  style?: React.CSSProperties;
  size?: number;
}

const Loader = ({ color = '#fff', text, style, size = 60 }: Props) => {
  return (
    <Wrapper role="progressbar" color={color} size={size}>
      <svg viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6">
          {text}
        </circle>
      </svg>
    </Wrapper>
  );
};

export default Loader;
